module.exports = __webpack_public_path__ + "58eeb9753faccff8cf18b8d280c695d1.png";